/* eslint-disable */
const ls = window.localStorage;
const lsPrefix = "zy_";
import overallData from "./overall";
import CryptoJS from 'crypto-js';

const utils = {
  // 2025-04-24 接口因为api-key权限问题，改用参数加密
  getAccessTokenParams (reqUrl, reqParams={},userToken) {				// API接口调用工具
    // 新增签名。去除apiKey
    const action = reqUrl.replace(overallData.axiosUrl,"").replace("/app","");
    const apiKey = "VH0GzX2SEBOuG2suY9i0CAi1lICvV9rM"
    const secretKey = "TvkUNzjhsFtvKSFQH4H2pB6u49nU8KFp";
    reqParams["apiKey"] = apiKey
    // 参数排序
    let sortParams = {}
    Object.keys(reqParams).sort().map(key => {
      sortParams[key] = reqParams[key]
    })

    // 参数key=value构成
    let reqStr = ''
    for (let i in sortParams) {
      if (sortParams[i] !== '') {
        let str = i + '=' + sortParams[i]
        reqStr += str + '&'
      }
    };
    if(userToken && userToken!=""){
      userToken = "&"+userToken
    }
    reqStr = reqStr+action+userToken+"&"+secretKey
    let qm = CryptoJS.MD5(reqStr)
    return qm
  },
	gotoLogin () {
		if (window.cc && window.cc.gotoLogin) {
			return window.cc.gotoLogin();
		}

		this.handleNativeOC('gotoLogin');

	   	return "";
	},

	getUserChannel () {
		if (window.cc && window.cc.getChannel) {
			return window.cc.getChannel();
		}

		this.handleNativeOC('getChannel');

	   	return "";
	},

	onTaskFinish (remianTime, TaskAllFinish) {
		if (window.cc) {
			return window.cc.onTaskFinish(remianTime, TaskAllFinish);
		}

		this.handleNativeOC('onTaskFinish', {
			remianTime,
			TaskAllFinish
		});

	   	return "";
	},

	orderInfo (orderInfo) {
		if (window.cc) {
			return window.cc.payOrder(orderInfo);
		}

		this.handleNativeOC('payOrder', orderInfo);

	   	return "";
	},

	closeWindow () {
		if (window.cc) {
			return window.cc.closeWindow();
		}

		this.handleNativeOC('closeWindow');

	   	return "";
	},

	openUrl (url, title) {
		if (window.cc) {
			return window.cc.openUrl(url, title);
		}

		this.handleNativeOC('openUrl', {
			url,
			title
		});

	   	return "";
	},

	getToken () {
		if (window.cc) {
			return window.cc.getToken();
		}

		return '355fa40975eb470884983065e0e4a1b2';
	},

	getSystemBarHeight () {
		if (window.cc) {
			return window.cc.getSystemBarHeight();
		}

		this.handleNativeOC('getSystemBarHeight');

		return 0;
	},

	getUserIcon () {
		if (window.cc) {
			return window.cc.getUserIcon();
		}

		this.handleNativeOC('getUserIcon');

	   	return "";
	},

	getUserName () {
		if (window.cc) {
			return window.cc.getUserName();
		}

		this.handleNativeOC('getUserName');

	   	return "";
	},

	copyText (content) {
		if (window.cc) {
			return window.cc.copyText(content);
		}

		this.handleNativeOC('copyText', {
	   		content
	   	});

	   	return "";
	},

	openVideoAd () {
		if (window.cc) {
			return window.cc.openVideoAd();
		}

		this.handleNativeOC('openVideoAd');

	   	return "";
	},

	toast (text, duration=1500) {
		if (window.cc) {
			return window.cc.toast(text, duration);
		}

	   	this.handleNativeOC('toast', {
	   		text,
	   		duration
	   	});

	   	return "";
	},

	share (title, content, url, icon="") {
		if (window.cc) {
			let appVersion = this.getVersionCode();
			if (appVersion) {
				return window.cc.share(title, content, url, icon);
			}
			return window.cc.share(title, content, url);
		}

		this.handleNativeOC('share', {
			title,
			content,
			url,
			icon
		});

	   	return "";
	},

	shareToQQ (title, content, url, icon="") {
		if (window.cc) {
			let appVersion = this.getVersionCode();
			if (appVersion) {
				return window.cc.shareToQQ(title, content, url, icon);
			}
			return window.cc.shareToQQ(title, content, url);
		}

		this.handleNativeOC('shareToQQ', {
			title,
			content,
			url,
			icon
		});

	   	return "";
	},

	shareToWeiXin (title, content, url, icon="") {
		if (window.cc) {
			let appVersion = this.getVersionCode();
			if (appVersion) {
				return window.cc.shareToWeiXin(title, content, url, icon);
			}
			return window.cc.shareToWeiXin(title, content, url);
		}

		this.handleNativeOC('shareToWeiXin', {
			title,
			content,
			url,
			icon
		});

	   	return "";
	},

	shareToMoments (title, content, url, icon="") {
		if (window.cc) {
			let appVersion = this.getVersionCode();
			if (appVersion) {
				return window.cc.shareToMoments(title, content, url, icon);
			}
			return window.cc.shareToMoments(title, content, url);
		}

		this.handleNativeOC('shareToMoments', {
			title,
			content,
			url,
			icon
		});

	   	return "";
	},

	shareToWeiBo (title, content, url, icon="") {
		if (window.cc) {
			let appVersion = this.getVersionCode();
			if (appVersion) {
				return window.cc.shareToWeiBo(title, content, url, icon);
			}
			return window.cc.shareToWeiBo(title, content, url);
		}

		this.handleNativeOC('shareToWeiBo', {
			title,
			content,
			url,
			icon
		});

	   	return "";
	},

	joinQQgroup (key) {
		if (window.cc) {
			return window.cc.joinQQGroup(key);
		}

		this.handleNativeOC('joinQQGroup', {
			key
		});

	   	return "";
	},

	openTopicDetail (id) {
		let topicId = id.toString();
		if (window.cc) {
			return window.cc.openTopicDetail(topicId);
		}

		this.handleNativeOC('openTopicDetail', {
			topicId
		});

	   	return "";
	},

	getVersionCode () {
		try {
            let versionCode = window.cc.getVersionCode();
            return versionCode;
        }
        catch(err){
            return 0;
        }
	},

	iosInitToken () {
		// if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getToken) {
		//     let params = {'url': 'Call APP method "getToken()"'}
		//     window.webkit.messageHandlers.getToken.postMessage(params);
		// };
	    this.handleNativeOC('getToken');
	},

	handleNativeOC (method, params={}) {
		if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[method]) {
			console.log("调用IOS：" + method + "，参数：");
			console.log(params);
	        window.webkit.messageHandlers[method].postMessage(params);
	    };
	},

	initSpeedTime(mins) {
		if (!mins) {
			return {
				h: '00',
				m: '00',
				s: '00',
			}
		}

		if (mins < 1) {
			let second = Math.floor(mins * 60);
			return {
				h: '00',
				m: '00',
				s: utils.strInit(seconds),
			}
		} else if (mins < 60) {
			return {
				h: '00',
				m: utils.strInit(mins),
				s: '00',
			}
		} else if (mins >= 60) {
			let hour = Math.floor(mins / 60);
			let min = mins % 60;

			return {
				h: utils.strInit(hour),
				m: utils.strInit(min),
				s: '00',
			}
		}
	},

	timeInit (timesStamp) {
		if (!timesStamp) {
			return "--";
		}
		let time = new Date(timesStamp);
		let year = time.getFullYear();
		let month = time.getMonth() + 1;
		let date = time.getDate();
		let hour = time.getHours();
		let min = time.getMinutes();
		let sec = time.getSeconds();

		return year + "-" + this.strInit(month) + "-" + this.strInit(date);
	},

	strInit (str) {
		if (str < 10) {
			return '0' + str;
		}
		return str;
	},

	getStorage (key) {
		key = lsPrefix + key;
		return ls.getItem(key);
	},

	setStorage (key, value) {
		key = lsPrefix + key;
		ls.setItem(key, value);
	},

	removeStorage (key) {
		key = lsPrefix + key;
		ls.removeItem(key);
	},

	getQueryParams (name) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		var r = window.location.search.substr(1).match(reg);
		if (r != null) return unescape(r[2]); return null;
	},

	isIos () {
		var u = navigator.userAgent;
	    if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
	        return true;
	    }
	    return false;
	},
};

export default utils;

